<template>
  <div class="opc-coupon-form opc-coupon-form__support-coupon">
    <div class="opc-coupon-form__inner">
      <zm-form label-position="inline" class="opc-coupon-form__coupon-code">
        <zm-form-item :label="$t('billing.coupon.coupon_input_placeholder')" :for="'opc-form-label-coupon-code' + uid">
          <zm-input
            class="opc-coupon-form__coupon-code-input"
            :class="isShowMessage ? 'opc-coupon-form__input-error' : ''"
            :id="'opc-form-label-coupon-code' + uid"
            v-model.trim="couponCode"
            :disabled="disableCouponInputForm"
            ref="couponInput"
          />
        </zm-form-item>
      </zm-form>
      <div v-if="isShowActionButton" :class="isShowActionButton ? 'opc-coupon-form__btn-wrapper' : ''">
        <zm-button
          round
          aria-label="Remove coupon"
          class="opc-coupon-form__cancel-btn text-capitalize"
          @click="handleRemoveCoupon">
          {{ $t('billing.common.remove') }}
        </zm-button>
      </div>
    </div>
    <div :role="isActive ? '' : 'alert'" ref="couponMsgRef" v-show="isShowMessage" :class="{ 'error-msg': !isActive }"
         class="opc-coupon-form__message">
      {{ message }}
    </div>
  </div>
</template>

<script>
import couponForm from '@/views/config/coupon/coupon-form.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { debounce } from 'lodash';
import { SupportCouponModeMap } from '@/views/config/coupon/component/support-coupon/constant';

export default {
  mixins: [couponForm],
  data() {
    return {
      unSupportedCouponCase: false,
    };
  },
  computed: {
    ...mapGetters([
      'supportCouponState',
      'currentEditPlan',
      'getSelectedPlans',
      'getSelectedPlansWithQuantityMap',
    ]),
    isShowActionButton() {
      return this.showCancelCta;
    },
    disableCouponInputForm() {
      return true;
    },
    needCallValidateApiInCheckoutPage() {
      return false;
    },
  },
  methods: {
    ...mapMutations(['setSupportCouponState']),
    ...mapActions(['verifySupportCoupon']),
    async autoVerifyCouponAction() {
      this.getPlansCouponInfo4SupportCoupon(this.couponCode);
    },
    handleRemoveCoupon() {
      this.removeCoupon();
      this.setSupportCouponState({
        couponDisplayMode: SupportCouponModeMap.banner,
      });
    },
  },
  created() {
    this.getPlansCouponInfo4SupportCoupon = debounce((couponCode) => {
      this.verifySupportCoupon({ couponCode });
    }, 500);

    this.couponCode = this.supportCouponState?.couponCode;
  },
};
</script>
